// 测试环境基础接口域名
// const devBaseURL = "http://three.api.viennareviews.xyz/api";
// const devBaseURL = "https://test.api.viennareviews.xyz/api";
// const devBaseURL = "https://h5.twglk.xyz/api";
const devBaseURL = "https://h5.helpingloantw.com/api";
// const devBaseURL = "https://twapi.viennareviews.xyz/api";
// const devBaseURL = "http://tw.api.viennareviews.xyz/api";
// const devBaseURL = "http://tw.h5.viennareviews.xyz/api";
// const devBaseURL = "http://47.243.104.233:4012/api";
// const devBaseURL = "http://47.76.143.92:4012/api";
// const devBaseURL = "https://vn.api.viennareviews.xyz/api";
// const devBaseURL = "https://h5.api.viennareviews.xyz/api";
// 生产环境基础接口域名
// const proBaseURL = "https://h5.twglk.xyz/api";
// const proBaseURL = "https://tw.zurdd.com/api";
const proBaseURL = "/api";

export const BASE_URL = process.env.NODE_ENV === "development" ? devBaseURL : proBaseURL;
export const LANGUAGE = process.env.NODE_ENV === "development" ? "zh" : "ch";

export const TIMEOUT = 200000;

// 网易易盾 => 无感知验证
// 无感知id
export const CAPTCHA_ID = "87d78b62062647d88c7e3a7c517c662c";

// 图片上传后压缩到的图片大小
export const IMAGE_LIMIT = 1;

// 密码加密盐
export const PASS_SALT = "signkey1";

